<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container" [ngClass]="{'container-fluid': router?.url === '/home-10' || router?.url === '/home-11'}">
        <a class="navbar-brand" routerLink="/">
            <img src="assets/img/AM_Media_title_logo.png" style="width: 230px;" alt="image">
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse admin-menu-direction" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item"><a routerLink="/admin/admin-blogs" class="nav-link">Blogs</a>
                </li>
                <li class="nav-item"><a routerLink="/admin/admin-events" class="nav-link">Events</a>
                </li>
                <li class="nav-item"><a routerLink="/admin/admin-courses" class="nav-link">Courses</a>
                </li>
                <li class="nav-item"><a href="Javascript:void();" (click)="logoutAdmin()" class="nav-link">Logout</a>
                </li>
            </ul>
        </div>
    </div>
</nav>